import React, { useState } from 'react';
import { ThumbsUp, ThumbsDown, Send, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';

const API_BASE = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = 'ybv_auth_token';

export function FeedbackWidget({ route }) {
  const [state, setState] = useState('idle');
  const [vote, setVote] = useState(null);
  const [comment, setComment] = useState('');

  const submit = async (useful) => {
    setVote(useful);
    setState('comment');
  };

  const send = async () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) return;
    try {
      await fetch(`${API_BASE}/api/analytics/feedback`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ route, useful: vote, comment: comment || null }),
      });
    } catch { /* silent */ }
    setState('done');
  };

  if (state === 'done') {
    return (
      <div className="flex items-center gap-2 text-xs text-stable" data-testid="feedback-thanks">
        <Check className="w-3.5 h-3.5" />
        <span>Thank you for your feedback.</span>
      </div>
    );
  }

  if (state === 'comment') {
    return (
      <div className="flex items-center gap-2" data-testid="feedback-comment">
        <input
          type="text"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Optional comment..."
          maxLength={200}
          className="h-7 px-2 text-xs bg-background border border-border/50 rounded text-foreground placeholder:text-muted-foreground/50 w-48 focus:outline-none focus:border-primary/50"
          data-testid="feedback-comment-input"
        />
        <Button variant="ghost" size="sm" onClick={send} className="h-7 px-2 text-xs" data-testid="feedback-send">
          <Send className="w-3 h-3 mr-1" />
          Send
        </Button>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3 text-xs text-muted-foreground" data-testid="feedback-widget">
      <span>Was this useful?</span>
      <button
        onClick={() => submit(true)}
        className="flex items-center gap-1 px-2 py-1 rounded hover:bg-stable/10 hover:text-stable transition-colors"
        data-testid="feedback-yes"
      >
        <ThumbsUp className="w-3 h-3" /> Yes
      </button>
      <button
        onClick={() => submit(false)}
        className="flex items-center gap-1 px-2 py-1 rounded hover:bg-destructive/10 hover:text-destructive transition-colors"
        data-testid="feedback-no"
      >
        <ThumbsDown className="w-3 h-3" /> No
      </button>
    </div>
  );
}

export default FeedbackWidget;
